import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { pushToDataLayer, GTMEvents } from './utils/gtm';
import favicon from './favicon.ico';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Set document title and favicon from src
document.title = 'Predicthire tools';
const existingFavicon = document.querySelector("link[rel='icon']");
const faviconLink = existingFavicon || document.createElement('link');
faviconLink.rel = 'icon';
faviconLink.href = favicon;
if (!existingFavicon) {
  document.head.appendChild(faviconLink);
}

// Send initial page view event
pushToDataLayer(GTMEvents.PAGE_VIEW(
  document.title,
  window.location.pathname
));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Track core web vitals
reportWebVitals((metric) => {
  if (metric.name === 'FCP' || metric.name === 'LCP' || metric.name === 'CLS') {
    pushToDataLayer({
      event: 'web_vitals',
      metric_name: metric.name,
      metric_value: Math.round(metric.value * 100) / 100,
    });
  }
});
